import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema, NotFoundError } from "./ApiClient";
import { TenantFormData } from "@/formTypes/TenantDataType";

export type TenantDataType = Partial<ApiSchema["Tenant"]["type"] & TenantFormData>;
class Api extends GenericModelApi<"Tenant", TenantDataType> {

    async fetchTenantBySuscriptionId(suscriptionId: string): Promise<TenantDataType> {
        const { data, errors } = await this.model.listTenantBySuscription({
            suscriptionId
        }, {
            limit: 1
        })
        if (errors || data.length == 0) {
            throw new NotFoundError(`No existe una suscripcion activa`, "API_ERROR", errors);
        } else {
            const tenant = data[0]
            return tenant
        }
    }

}
export const TenantApi = new Api("Tenant", "nombre", "ASC");